(function () {
  'use strict';

  var PROP = '_SpecialOrder';
  var SECTION = 'special-order-data';
  var cache = {};
  var syncing = false;
  var queued = false;

  function getProductData(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '?section_id=' + SECTION)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-special-order-data]');
        return el ? JSON.parse(el.textContent) : null;
      })
      .catch(function () { return null; });
    return cache[handle];
  }

  function isSpecialOrder(data, variantId, quantity) {
    if (!data || !data.valid_status) return false;
    var v = (data.variants || []).find(function (x) {
      return Number(x.id) === Number(variantId);
    });
    if (!v) return false;
    return v.inventory_policy === 'continue' &&
           v.available === true &&
           Number(quantity) > Number(v.inventory_quantity || 0);
  }

  function changeLine(key, quantity, properties) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, properties: properties })
    });
  }

  function sync() {
    if (syncing) { queued = true; return Promise.resolve(); }
    syncing = true;

    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        return Promise.all(items.map(function (item) {
          return getProductData(item.handle).then(function (data) {
            return { item: item, want: isSpecialOrder(data, item.variant_id, item.quantity) };
          });
        }));
      })
      .then(function (results) {
        // sequential — concurrent cart writes conflict and re-key lines
        return results.reduce(function (chain, r) {
          return chain.then(function (changed) {
            var props = Object.assign({}, r.item.properties || {});
            var has = props[PROP] === 'true' || props[PROP] === true;
            if (r.want === has) return changed;
            if (r.want) { props[PROP] = 'true'; } else { delete props[PROP]; }
            return changeLine(r.item.key, r.item.quantity, props).then(function () { return true; });
          });
        }, Promise.resolve(false));
      })
      .then(function (changed) {
        if (changed) {
          document.dispatchEvent(new CustomEvent('special-order:cart-updated'));
        }
      })
      .catch(function () { /* never block the shopper */ })
      .then(function () {
        syncing = false;
        if (queued) { queued = false; return sync(); }
      });
  }

  function isCartWrite(url) {
    if (!url) return false;
    url = String(url);
    if (url.indexOf('/cart/change') > -1 && syncing) return false; // ignore our own writes
    return /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
  }

  // --- intercept fetch ---
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
    var p = _fetch.apply(this, arguments);
    if (isCartWrite(url)) { p.then(function () { setTimeout(sync, 60); }).catch(function () {}); }
    return p;
  };

  // --- intercept XHR (jQuery / older theme code) ---
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__soUrl = u;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (isCartWrite(this.__soUrl)) {
      this.addEventListener('load', function () { setTimeout(sync, 60); });
    }
    return _send.apply(self, arguments);
  };

  // --- initial pass + safety nets ---
  function boot() { setTimeout(sync, 400); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });

  window.SpecialOrderSync = sync; // manual trigger for debugging
})();